// extracted by mini-css-extract-plugin
export default {"TopBarContainer":"TopBar_TopBarContainer__TuYvf","BackBtn":"TopBar_BackBtn__xMCq9","Title":"TopBar_Title__ji3s+"};